import React from 'react';
import { Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { tokens } from '../theme';

/**
 * The line under a field that says what is wrong with it.
 *
 * Was 1rem in a hardcoded pink — larger than the label above it and a
 * different red from the rest of the app, so a single missing date shouted
 * louder than the question it belonged to. Used in 38 places, so the volume
 * was set once and heard everywhere.
 *
 * Now it reads as an annotation on the field: the same 0.75rem the other
 * helper text uses, the theme's danger colour, and an icon so the meaning
 * survives for anyone who cannot pick the red out — an error carried by colour
 * alone is not carried at all.
 *
 * Renders nothing when there is nothing to say, rather than an empty element
 * that still occupies the line.
 */
const ErrorMsg = ({ children }) => {
  if (!children) return null;
  return (
    <Box
      // announced, because somebody who has just pressed save may not be
      // looking at the field that failed
      role="alert"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.25rem',
        mt: '0.25rem',
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
        color: tokens.danger,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: '0.875rem', mt: '0.0625rem', flexShrink: 0 }} />
      <Box component="span">{children}</Box>
    </Box>
  );
};

export default ErrorMsg;
